import React from "react";
import { Link, useParams } from "react-router-dom";
import ProductData from "./ProductData";
import "./ProductDetails.css";

const ProductDetails = () => {
  const { slug } = useParams();

  const product = ProductData.find(
    (item) => item.slug === slug
  );

  /* =====================================================
     PRODUCT NOT FOUND
  ===================================================== */

  if (!product) {
    return (
      <div className="product-details-not-found">

        <div className="container">

          <div className="product-not-found-content">

            <span>
              DNK SOFTWARE
            </span>

            <h1>
              Product Not Found
            </h1>

            <p>
              The product you are looking for could not be found.
            </p>

            <Link
              to="/products"
              className="product-details-back-btn"
            >
              ← Back to Products
            </Link>

          </div>

        </div>

      </div>
    );
  }


  return (
    <div className="product-details-page">


      {/* =====================================================
          PRODUCT HERO
      ===================================================== */}

      <section className="product-details-hero">


        {/* Decorative Elements */}

        <div
          className="product-details-glow product-details-glow-one"
        ></div>

        <div
          className="product-details-glow product-details-glow-two"
        ></div>

        <div className="product-details-grid"></div>


        <div className="container">

          <div className="row align-items-center">


            {/* =================================================
                LEFT CONTENT
            ================================================= */}

            <div
              className="col-lg-6 col-md-12"
              data-aos="fade-right"
            >

              <div className="product-details-content">


                {/* CATEGORY */}

                <span className="product-details-category">
                  {product.tag}
                </span>


                {/* PRODUCT NAME */}

                <h1>
                  {product.name}
                </h1>


                {/* TAGLINE */}

                <h2>
                  {product.tagline}
                </h2>


                {/* DESCRIPTION */}

                <p className="product-details-description">
                  {product.description}
                </p>


                {/* =================================================
                    MODULE LIST
                ================================================= */}

                <div className="product-details-module-list">

                  {Array.isArray(product.modules) &&
                    product.modules.map(
                      (module, index) => (

                        <span
                          className="product-details-module"
                          key={`${product.slug}-module-${index}`}
                        >

                          <i className="fas fa-check"></i>

                          {module.name}

                        </span>

                      )
                    )}

                </div>


                {/* =================================================
                    BUTTONS
                ================================================= */}

                <div className="product-details-actions">


                  <a
                    href="#product-capabilities"
                    className="product-details-primary-btn"
                  >

                    Explore Features

                    <span>
                      →
                    </span>

                  </a>


                  <Link
                    to="/products"
                    className="product-details-secondary-btn"
                  >

                    ← All Products

                  </Link>


                </div>

              </div>

            </div>


            {/* =================================================
                RIGHT PRODUCT VIDEO
            ================================================= */}

            <div
              className="col-lg-6 col-md-12"
              data-aos="fade-left"
            >

              <div className="product-details-visual">


                {/* VIDEO GLOW */}

                <div className="product-details-image-glow"></div>


                {/* BROWSER MOCKUP */}

                <div className="product-details-browser">


                  {/* Browser Header */}

                  <div className="product-browser-header">


                    {/* Browser Dots */}

                    <div className="product-browser-dots">

                      <span></span>

                      <span></span>

                      <span></span>

                    </div>


                    {/* Browser Address */}

                    <div className="product-browser-address">

                      {product.name}

                    </div>

                  </div>


                  {/* =================================================
                      PRODUCT VIDEO
                  ================================================= */}

                  <div className="product-browser-screen">

                    {product.video ? (

                      <video
                        className="product-demo-video"
                        src={product.video}
                        autoPlay
                        muted
                        loop
                        playsInline
                        controls
                        preload="metadata"
                      >
                        Your browser does not support the video tag.
                      </video>

                    ) : (

                      <img
                        src={product.image}
                        alt={`${product.name} software`}
                        className="product-demo-video"
                      />

                    )}

                  </div>


                </div>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          PRODUCT CAPABILITIES
      ===================================================== */}

      <section
        id="product-capabilities"
        className="product-capabilities"
      >

        <div className="container">


          {/* =================================================
              SECTION HEADING
          ================================================= */}

          <div
            className="product-details-section-heading"
            data-aos="fade-up"
          >

            <span>
              PRODUCT CAPABILITIES
            </span>

            <h2>
              Everything You Need
              <br />
              In One Platform.
            </h2>

            <p>
              {product.name} brings the essential tools
              your team needs into one simple and connected
              workspace.
            </p>

          </div>


          {/* =================================================
              MODULE CARDS
          ================================================= */}

          <div className="row">

            {Array.isArray(product.modules) &&
              product.modules.map(
                (module, index) => (

                  <div
                    className="col-lg-4 col-md-6 col-12"
                    key={`${product.slug}-capability-${index}`}
                    data-aos="fade-up"
                    data-aos-delay={index * 80}
                  >

                    <div className="product-capability-card">


                      {/* NUMBER */}

                      <div className="product-capability-number">

                        {String(index + 1).padStart(
                          2,
                          "0"
                        )}

                      </div>


                      {/* ICON */}

                      <div className="product-capability-icon">

                        <i className="fas fa-layer-group"></i>

                      </div>


                      {/* MODULE NAME */}

                      <h3>

                        {module.name}

                      </h3>


                      {/* MODULE DESCRIPTION */}

                      <p>

                        {module.description}

                      </p>


                      {/* ARROW */}

                      {/* <div className="product-capability-arrow">

                        →

                      </div> */}


                    </div>

                  </div>

                )
              )}

          </div>

        </div>

      </section>


      {/* =====================================================
          PRODUCT HIGHLIGHT
      ===================================================== */}

      <section className="product-highlight">

        <div className="container">

          <div className="product-highlight-box">


            {/* CONTENT */}

            <div className="product-highlight-content">

              <span>
                BUILT FOR MODERN TEAMS
              </span>


              <h2>
                Simplify Work.
                <br />
                Accelerate Growth.
              </h2>


              <p>
                {product.name} helps businesses reduce
                complexity, organize their workflows and
                bring teams together through one powerful
                platform.
              </p>


              <Link
                to="/contact"
                className="product-details-primary-btn"
              >

                Talk to Our Team

                <span>
                  →
                </span>

              </Link>

            </div>


            {/* DECORATION */}

            <div className="product-highlight-decoration">

              <div className="highlight-circle circle-one"></div>

              <div className="highlight-circle circle-two"></div>

              <div className="highlight-circle circle-three"></div>

            </div>


          </div>

        </div>

      </section>


      {/* =====================================================
          BOTTOM CTA
          Currently disabled
      ===================================================== */}

      {/*
      <section className="product-details-cta">

        <div className="container">

          <div className="product-details-cta-content">

            <span>
              READY TO GET STARTED?
            </span>

            <h2>
              Let's Build Something
              Better Together.
            </h2>

            <Link
              to="/contact"
              className="product-details-primary-btn"
            >
              Contact DNK Software

              <span>
                →
              </span>

            </Link>

          </div>

        </div>

      </section>
      */}


    </div>
  );
};


export default ProductDetails;